<section *ngIf="!editingCustomEndpoint">
  <nz-skeleton [nzActive]="true"
               [nzLoading]="!editingCustomEndpoint"
               [nzTitle]="false"
               [nzParagraph]="{ rows: 2 }">
  </nz-skeleton>
</section>
<rappider-title-toolbar *ngIf="editingCustomEndpoint"
                        [mainTitle]="mainTitle"
                        [options]="title"
                        [displayToolbar]="displayToolbar"
                        [displayToolbarBackButton]="displayToolbarBackButton">
</rappider-title-toolbar>

<section>
  <rappider-spin [spinning]="!customFunctionId && !isEnableSubmitButton">
    <rappider-crud-view-edit-form [config]="CUSTOM_ENDPOINT_EDIT_CONFIG"
                                  [data]="editingCustomEndpoint"
                                  [submitButtonLoading]="isSubmitButtonLoading"
                                  (fieldValueChange)="onCustomEndpointFormValueChange($event)"></rappider-crud-view-edit-form>

    <rappider-custom-function-edit-wrapper *ngIf="customFunctionId"
                                           [enableSubmitButton]="isEnableSubmitButton"
                                           [customFunction]="customFunction"
                                           [activeCustomFunctionId]="customFunctionId"
                                           [submitButtonLoading]="isSubmitButtonLoading"
                                           [visibleFields]="visibleFields"
                                           (updateFormSubmit)="onCustomEndpointUpdate($event)"></rappider-custom-function-edit-wrapper>
  </rappider-spin>
</section>